var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":function($event){return _vm.onclick()}}},[_c('img',{staticClass:"order-item-icon",attrs:{"src":_vm.src}}),_c('label',{staticClass:"item-title order-item-title"},[_vm._v(_vm._s(_vm.title))]),(_vm.orderNumber == 0 ? '': _vm.orderNumber )?_c('span',{staticClass:"number"},[_vm._v(_vm._s(_vm.orderNumber))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }